"use client";

import Script from "next/script";

// Онлайн-чат Callibri (Калибри) — перенесён с OLD-сайта autopilotrent.ru.
// Скрипт сам подгружает виджет по зарегистрированному в Callibri домену.
export default function CallibriChat() {
  return (
    <Script
      id="callibri-chat"
      src="https://cdn.callibri.ru/callibri.js"
      strategy="afterInteractive"
    />
  );
}
